@if (tooltip(); as tooltip) {
    @let size = tooltipIconSize();
    @let visualId = tooltip.icon | visualId: value();
    @let source = (visualId | fetchVisual | async) || sourcePlaceholder;
    <img
        class="ca-visual-icon"
        [style.width.px]="size"
        [style.height.px]="size"
        [attr.alt]="visualId"
        [src]="source"
        matTooltipPosition="above"
        matTooltipClass="ca-tooltip"
        [matTooltip]="tooltip.contentKey | translationKey: tooltip.contentData"
    />
} @else {
    @let visualId = slot()?.visual?.visualId | visualId: value();
    @let size = iconSize();
    @let source = (visualId | fetchVisual | async) || sourcePlaceholder;
    @if (size) {
        <img class="ca-visual-icon" [style.width.px]="size" [style.height.px]="size" [attr.alt]="visualId" [src]="source" />
    } @else {
        <img [class.ca-visual-icon]="slot()?.visual?.visualType === visualType.Icon" [attr.alt]="visualId" [src]="source" />
    }
}
